// Cliente 360 (Ola 3): la tab Info es un layout de DOS COLUMNAS
// (layout aprobado por el dueño):
//   Izquierda: tarjeta única de datos del cliente (cuenta + contacto +
//              auditoría + faltantes agregados)
//   Derecha:   Celda KPIs (mora / factura del período / último pago) · gráfica
import { Col, Row } from 'antd';
import { ClienteInfoGeneralCard } from './ClienteInfoGeneralCard';
import { ClienteKPIsFinancieros } from './ClienteKPIsFinancieros';
import { ClienteSerieMensualChart } from './ClienteSerieMensualChart';
import type { ClienteResponse } from '@aid/shared';

interface ClienteInfoTabProps {
  cliente: ClienteResponse;
}

export function ClienteInfoTab({ cliente }: ClienteInfoTabProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Row gutter={[16, 16]}>
        {/* Columna izquierda: datos del cliente en una sola tarjeta — 1/4 */}
        <Col xs={24} lg={6}>
          <ClienteInfoGeneralCard cliente={cliente} />
        </Col>
        {/* Columna derecha: KPIs arriba, Gráfica abajo — 3/4 */}
        <Col xs={24} lg={18}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <ClienteKPIsFinancieros cliente={cliente} />
            <ClienteSerieMensualChart clienteId={cliente.id} />
          </div>
        </Col>
      </Row>
    </div>
  );
}
